import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import erns from './erns'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    erns,
  },
  strict: process.env.DEV,
})
